
import React, { useEffect, useState } from 'react';
import {
    useFrontDeskState,
    useFrontDeskDispatch,
    CHANGE_TAB,
    SET_TEMPLATE,
    RESET
} from 'context/frontdesk'
import bootbox from 'components/Modals/Bootbox';
import { createFromQuestionnaire } from 'api/actions/templates';
import { useMutation, useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';
import { fetcher } from 'api/client';
import { useForm } from 'react-hook-form';
import { parseDate } from 'utils';
import { Card, CardBody, CardText, CardSubtitle, Button, Form } from 'reactstrap';
import { toast } from 'components/Shared/Toast';
import clsx from 'clsx';
import { useHistory } from 'react-router-dom';

export function TemplateItem({ template }) {
    const { questions, createdAt, name, user, _id } = template;
    const dispatch = useFrontDeskDispatch();
    const { t } = useTranslation()
    const frontdeskState = useFrontDeskState();
    const history = useHistory();

    const handleInit = async () => {
        if (frontdeskState.isModified && !await bootbox.confirm(t('frontDesk.confirm_close'))) {
            return
        }
        if (await bootbox.confirm(t('frontDesk.listing.templates.new_process_template', { replace: { templatename: name } }))) {
            dispatch({ type: SET_TEMPLATE, templateId: _id, questions });
            history.push('/frontdesk');
        }
    }

    return (
        <Card
            className={clsx('rounded-lg shadow-sm pointer my-2', _id === frontdeskState.templateId && 'shadow')}
            onClick={handleInit}>
            <CardBody >
                <div className="font-weight-bold">
                    {name}
                </div>
                <hr></hr>
                <CardText>{questions?.length} {t('frontDesk.questions')}</CardText>
                <CardSubtitle className="text-muted"><small>{parseDate(createdAt, 'PP')}</small></CardSubtitle>
                <CardText>{user?.name}</CardText>
            </CardBody>
        </Card>
    )
}

export function Template() {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const frontdeskState = useFrontDeskState();
    const dispatch = useFrontDeskDispatch();
    const history = useHistory();
    const { register, handleSubmit, errors } = useForm({ mode: 'all' });
    const { mutate: createMutation, error, isLoading } = useMutation((payload) => fetcher(createFromQuestionnaire(payload)), {
        onSuccess: async (createdContract) => {
            await queryClient.invalidateQueries('contracts-questionnaire')
            history.push(`/frontdesk/contract/${createdContract._id}`)
            dispatch({ type: CHANGE_TAB, tab: 'contracts' })
        },
        onError: (error) => {
            const msg = t(`errors.${error.message}`, t('errors.GeneralError'));
            toast.error(msg);
        }
    });
    const doSubmit = (questions) => {
        createMutation({
            preventSave: false,
            _id: frontdeskState.templateId,
            answers: Object.keys(questions).map((q) => ({ question: q, answer: questions[q] }))
        })
    }
    const handleBack = () => {
        dispatch({ type: RESET });
    }

    if (!frontdeskState.templateId) return null;

    return (
        <Form onSubmit={handleSubmit(doSubmit)} className="h-100">
            <Card className="rounded-lg h-100">
                <CardBody className="h-100 d-flex flex-column h-100 overflow-hidden pb-2">
                    <div className="bg-white border-bottom p-1">
                        <h5><b>{t('frontDesk.complete_questions')}</b></h5>
                    </div>
                    <div className="h-100 overflow-y-auto mt-2 border-bottom">
                        <ol className="mt-2">
                            {
                                frontdeskState?.questions?.length ?
                                    frontdeskState?.questions?.map((question) => (
                                        <li key={question._id} className="mt-3">
                                            <span>{question.content}</span>
                                            <ol className="mt-2">
                                                {question?.answers?.map((answer) => (
                                                    <div key={answer._id} className="mt-1">
                                                        <input
                                                            name={question._id}
                                                            type="radio"
                                                            value={answer._id}
                                                            ref={register({ required: true })}
                                                        />
                                                        <span className="ml-3">{answer.content}</span>
                                                    </div>
                                                ))}
                                            </ol>
                                        </li>
                                    )) :
                                    <ol className="mt-2">{t('frontDesk.no_questions')}</ol>
                            }
                        </ol>
                    </div>
                    <div className="text-right mt-2">
                        <small hidden={!Boolean(Object.keys(errors).length)}
                            className="text-danger"
                        >
                            {t('frontDesk.missing_questions')}
                        </small>
                        <small hidden={!error}
                            className="text-danger"
                        >
                            {t(`errors.${error?.message}`)}
                        </small>
                        <div >
                            <Button className="" color="secondary" onClick={handleBack} disabled={isLoading}>
                                {t('frontDesk.cancel')} <i className="pl-1 fas fa-times"></i>
                            </Button>
                            <Button className="ml-2" color="primary" disabled={isLoading}>
                                {t('frontDesk.generate')} <i className={clsx('pl-1 fas', isLoading ? 'fa-spinner fa-spin' : 'fa-check')}></i>
                            </Button>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </Form>
    )
}